export default (config) => {
  const {
    netlib,
    apiWrap,
    accessToken,
    tenant,
  } = config;

  const getRevenueByEcid = (filters = {}, granularity) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.RevenueApi.getRevenueByEcid(
        accessToken,
        tenant,
        {
          ...filters,
          includeParticipants: true,
          includeNames: true,
          granularity,
        },
      );
      return data;
    },
  });

  return {
    getRevenueByEcid,
  };
};
